  <template>
  <div>
   <b-modal style="padding:15px" size="lg" id="EditProductionModal" ref="modal" title="Edit Production" ok-title="Submit" cancel-title="Close" 
      @hidden= "resetModal()" @show= "updateModal()" @ok= "handleOk" :ok-disabled = "this.$refs.EditProductionForm != undefined ? !this.$refs.EditProductionForm.checkValidity() : true">
        <form ref="EditProductionForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
           
            <div class="col-md-6">
               <b-form-group  label="Production Date" label-for="datepicker-1" autocomplete="off">
                  <b-form-datepicker id="datepicker-1" v-model= "ProDate" placeholder="Choose a date" local="en" required></b-form-datepicker>
               </b-form-group>
             
            </div>
            <div  class="col-md-6">
               <b-form-group label="Time" label-for="Time" autocomplete="off">
                <b-form-select v-model= "SelectedTimeSlot" :options="timeSlots" value-field="id" text-field="timeSlot" required>
                  <b-form-select-option :value = null disabled hidden>Select Time</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Flour Type" label-for="Flour Type" autocomplete="off">
                <b-form-select v-model= "SelectedFlourType" :options="flourTypes" value-field="id" text-field="name" @change="getFlourWeights()" required>
                  <b-form-select-option :value = null disabled hidden>Select Type</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Flour Weight" label-for="Flour Weight" autocomplete="off">
                <b-form-select v-model= "SelectedFlourWeight" :options="flourWeights" value-field="flourWeight.id" text-field="flourWeight.weight" required>
                  <b-form-select-option :value = null disabled hidden>Select Weight</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
             <div class="col-md-4">
                <b-form-group  label="No Of Sacks" label-for="No Of Sacks" autocomplete="off">
                <b-form-input id="NoofSacks" v-model= "NoOfSacks" type = "number" required></b-form-input>
              </b-form-group>
            </div>
             <div class="col-md-12">
              <b-form-textarea id="textarea"  v-model= "Comments"  placeholder="Comments" rows="3" max-rows="6"></b-form-textarea>
             </div>  
          </div>     
        </form>
      </b-modal>
        <Toaster ref="toaster"/>
  </div>
      </template>

      <script>
import axios from 'axios';
// import config from '../config.js'; 
import Toaster from '../../toaster'
export default {
    name: 'AddProduction',
    data(){
        return{
          moduleName:'Add Production',   
          Id:null,
          Comments:null,
          CompanyId:null,
          flourWeights:null,
          flourTypes:null,
          timeSlots:null,
          SelectedTimeSlot:null,
          SelectedFlourType:null,
          SelectedFlourWeight:null,
          NoOfSacks:0,
         
          ProDate:new Date(),
        
		}
  },
props:{
  prodToEdit:{
    type:Object,
    default:null
  }
},
 components:
     {
      Toaster
    },
created()
{
  this.gettimeSlots();
  this.getFlourWeights();
  this.getFlourTypes();
},

methods:{

  getFlourWeights()
  { 
     axios.post('/flourweighttypelink/getAll', 
      {"CompanyId":this.$auth.user().companyId,"FlourTypeId":this.SelectedFlourType})
      .then(res=>{
        console.log(res.data)
            if(res.data.status == 1)
            {
               this.flourWeights = res.data.data;
            }
            else if(res.data.status == -1)
            {
                this.$bvModal.msgBoxOk(res.data.msg, {
                title: 'Error',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
             
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
  },
    
    gettimeSlots()
    { 
        
     axios.post('/timeslots/getall', 
      { "CompanyId":this.$auth.user().companyId})
      .then(res=>{
         console.log(res.data)
            if(res.data.status == 1)
            {
               this.timeSlots = res.data.data;
            }
            else if(res.data.status == -1)
            {
                this.$bvModal.msgBoxOk(res.data.msg, {
                title: 'Error',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
             
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

     getFlourTypes()
    { 
        
     axios.post('/flourtype/getall', 
      { "CompanyId":this.$auth.user().companyId})
      .then(res=>{
         console.log(res.data)
            if(res.data.status == 1)
            {
               this.flourTypes = res.data.data;
            }
            else if(res.data.status == -1)
            {
                this.$bvModal.msgBoxOk(res.data.msg, {
                title: 'Error',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
             
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   addProduction(){ 
    
        let model =
         {
           'Id':this.Id,
           "NoOfSacksProduced":Number(this.NoOfSacks),
           "ProductionDate":this.ProDate,
           "Description":this.Comments,
           "TimeId":this.SelectedTimeSlot,
           "UserId":this.$auth.user().id,
           "FlourWeightId":this.SelectedFlourWeight,
           "FlourTypeId":this.SelectedFlourType,
           "CompanyId":this.$auth.user().companyId
          }
          console.log(model)
     axios.post('/production/edit', model)
      .then(res=>{
            if(res.data.status == 1)
            {
                this.$refs.toaster.showToast('Success','success','Production has been edited successfully');
                this.$bvModal.hide('EditProductionModal')
                this.$parent.getPage();
            }
            else if(res.data.status == -1)
            {
                this.$refs.toaster.showToast('Error','danger',res.data.msg);
             
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   checkFormValidity() {
        const valid = this.$refs.EditProductionForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
     
      resetModal() {
        this.NoOfSacks = 0;
        this.ProDate = new Date();
        this.SelectedTimeSlot = null;
        this.SelectedFlourType = null;
        this.SelectedFlourWeight = null;  
        this.Comments = null;
      },
      updateModal() {
        console.log(this.prodToEdit)
        this.Id = this.prodToEdit.id;
        this.NoOfSacks = this.prodToEdit.noOfSacksProduced;
        this.ProDate = this.prodToEdit.productionDate
        this.SelectedTimeSlot = this.prodToEdit.timeId
        this.SelectedFlourType = this.prodToEdit.flourTypeWeightLink.flourTypeId
        this.SelectedFlourWeight =this.prodToEdit.flourTypeWeightLink.flourWeightId
        this.Comments = this.prodToEdit.description
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.addProduction()
       
      },

 

  }
	

}
</script>
